import { StylesConfig } from 'react-select';
import { DefaultTheme } from 'styled-components';

type GetSelectedStylesOptionsT = {
  inputIconUrl?: string;
  isError?: boolean;
  isAlignRight?: boolean;
  isAlignCenter?: boolean;
};

export function getSelectStyles<OptionT>(
  theme: DefaultTheme,
  options: GetSelectedStylesOptionsT
): StylesConfig<OptionT, boolean> {
  const leftIconStyles = options.inputIconUrl
    ? {
        ':before': {
          content: '""',
          height: 18,
          width: 18,
          backgroundImage: `url(${options.inputIconUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
        },
      }
    : '';

  return {
    control(provided, state) {
      let borderColor = '#d0d0d0';

      if (state.isFocused) {
        borderColor = theme.primaryColour;
      }

      if (state.isDisabled) {
        borderColor = 'transparent';
      }

      if (options.isError) {
        borderColor = '#dc3545';
      }

      return {
        ...provided,
        borderColor,
        boxShadow: 'none',
        height: '42px',
        padding: '5px 10px',

        '&:hover': {
          borderColor: theme.primaryColour,
        },

        ...leftIconStyles,
      };
    },
    menu: provided => ({
      ...provided,
      marginTop: 5,
      padding: 5,
      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
      ...(options.isAlignRight && { right: 0 }),
      ...(options.isAlignCenter && { left: '50%', transform: 'translateX(-50%)' }),
    }),
    option: (provided, state) => ({
      ...provided,
      color: theme.textColour,
      backgroundColor: state.isFocused || state.isSelected ? '#E9E9EC' : '',
      padding: '5px 10px',
      borderRadius: 4,
      textTransform: 'capitalize',

      '&:active': {
        backgroundColor: '#E9E9EC',
      },
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    valueContainer: provided => ({
      ...provided,
      textTransform: 'capitalize',
      padding: 0,
    }),
    singleValue: provided => ({
      ...provided,
      color: '#000',
    }),
    dropdownIndicator(provided, state) {
      if (state.isDisabled || state.selectProps.isSearchable) {
        return {
          display: 'none',
        };
      }

      return {
        ...provided,
        padding: 0,
      };
    },
    clearIndicator(provided) {
      return {
        ...provided,
        padding: 0,
      };
    },
  };
}
